/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import { injectIntl } from 'react-intl'
import { RaisedButton, CircularProgress } from 'material-ui'

import Card from 'generic/card/Card'

import * as constants from 'constants/Header'

class FileImportPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      options: [
        {
          title: this.props.intl.formatMessage(constants.messages.CUSTOMER_IMPORT_TITLE),
          ref: this.customer,
          fileType: '.xml',
          action: this.props.handleXMLUpload,
          loading: 'loadingCustomer',
          message: 'customer',
          fileName: 'customer_import.xml'
        },
        {
          title: this.props.intl.formatMessage(constants.messages.INTERPRETER_IMPORT_TITLE),
          ref: this.interpreter,
          fileType: '.xlsx',
          action: this.props.handleXLSXUpload,
          loading: 'loadingInterpreter',
          message: 'interpreter',
          fileName: 'interpreter_import.xlsx'
        }
      ]
    }
  }

  render () {
    return (
      <Card
        title={this.props.intl.formatMessage(constants.messages.CUSTOMER_INTERPRETER_IMPORT_MENU)}
        style={{
          height: '86vh',
          width: '60%',
          marginLeft: '20%',
        }}
      >
        {
          this.state.options.map((option, key) => {
            return (
              <div
                key={key}
                style={{width: '50%', float: 'left'}}
              >
                {
                  this.props[option.loading]
                    ? <CircularProgress
                        size={200}
                        style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          paddingTop: 10,
                        }}
                      />
                    : <div style={{paddingTop: '10vh', textAlign: 'center'}}>
                      <input
                        accept={option.fileType}
                        ref={(ref) => option.ref = ref}
                        type="file"
                        style={{display: 'none'}}
                        onChange={(event) => option.action(event, option)}
                      />
                      <RaisedButton
                        style={{width: 300, textOverflow: 'ellipsis'}}
                        labelStyle={{fontSize: 12, padding: 0}}
                        primary={true}
                        label={option.title}
                        onClick={() => this.props.handleFileUpload(option.ref)}
                      />

                      {
                        this.props.messageParams &&
                        this.props.messageParams[option.message]
                          ? <div style={{color: this.props.messageParams[option.message].color, paddingTop: 10}}>
                            {this.props.messageParams[option.message].message}
                          </div>
                          : undefined
                      }
                    </div>
                }
              </div>
            )
          })
        }
      </Card>
    )
  }
}

export default injectIntl(FileImportPage)



// WEBPACK FOOTER //
// ./src/components/staff/FileImportPage.js